import apiClient from './api';
import { API_CONFIG } from '../utils/constants';
import { Ventas } from '../models/Ventas';
import { VentasDetalle } from '../models/VentasDetalle';

export class VentasService {
  
  // ============================================
  // CREAR NUEVA VENTA CON DETALLES
  // ============================================
  static async createVenta(ventaData, detallesData) {
    try {
      console.log('🔍 === CREATE VENTA DEBUG ===');
      console.log('🔍 Datos de venta recibidos:', ventaData);
      console.log('🔍 Detalles recibidos:', detallesData);

      // Validar que vengan los detalles
      if (!detallesData || !Array.isArray(detallesData) || detallesData.length === 0) {
        throw new Error('Debe incluir al menos un detalle de venta');
      }

      // Crear instancia del modelo Ventas
      const venta = new Ventas(ventaData);
      console.log('🔍 Venta mapeada:', venta.toDebug());

      // Validar venta
      if (!venta.isValid()) {
        const errors = venta.getValidationErrors();
        console.error('❌ Validación fallida:', errors);
        throw new Error('Datos de venta inválidos: ' + errors.join(', '));
      }

      // Crear instancias de los detalles
      const detalles = detallesData.map((detalle, index) => {
        console.log(`🔍 Procesando detalle ${index}:`, detalle);
        const detalleObj = new VentasDetalle(detalle);
        
        // Validar cada detalle
        if (!detalleObj.isValid()) {
          const errors = detalleObj.getValidationErrors();
          console.error(`❌ Validación fallida en detalle ${index}:`, errors);
          throw new Error(`Detalle ${index + 1} inválido: ${errors.join(', ')}`);
        }
        
        console.log(`✅ Detalle ${index} mapeado:`, detalleObj.toDebug());
        return detalleObj.toApiFormat();
      });

      // Construir objeto para enviar a la API
      const dataToSend = {
        venta: venta.toApiFormat(),
        detalles: detalles
      };

      console.log('📤 Data a enviar al API:', JSON.stringify(dataToSend, null, 2));
      console.log('📤 URL:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.VENTAS);

      // Realizar petición POST
      const response = await apiClient.post(API_CONFIG.ENDPOINTS.VENTAS, dataToSend);
      
      console.log('✅ Respuesta del servidor:', response.data);

      // Manejar respuesta del servidor
      let ventaCreada;
      if (response.data.success && response.data.data) {
        ventaCreada = response.data.data;
      } else if (response.data.venta) {
        ventaCreada = response.data.venta;
      } else {
        ventaCreada = response.data;
      }

      console.log('✅ Venta creada exitosamente:', ventaCreada);
      
      return {
        success: true,
        data: new Ventas(ventaCreada),
        message: 'Venta creada exitosamente'
      };

    } catch (error) {
      console.error('❌ === ERROR CREATE VENTA ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error response:', error.response);
      console.error('❌ Error message:', error.message);
      
      if (error.response) {
        console.error('❌ Status:', error.response.status);
        console.error('❌ Data:', error.response.data);
      }
      
      throw new Error('Error al crear la venta: ' + (error.response?.data?.message || error.message));
    }
  }

  // ============================================
  // OBTENER VENTAS POR ID_SUCURSAL
  // ============================================
  static async getVentasBySucursal(idSucursal) {
    try {
      console.log('🔍 === GET VENTAS BY SUCURSAL DEBUG ===');
      console.log('🔍 ID Sucursal:', idSucursal);

      if (!idSucursal) {
        console.error('❌ ID de sucursal no proporcionado');
        return {
          success: false,
          data: [],
          count: 0
        };
      }

      const url = `${API_CONFIG.ENDPOINTS.VENTAS}/sucursal/${idSucursal}`;
      console.log('🔍 URL completa:', API_CONFIG.BASE_URL + url);

      const response = await apiClient.get(url);
      console.log('✅ Respuesta cruda del API:', response.data);

      let ventasArray = [];

      // CASO 1: Array directo de objetos {venta, detalles}
      if (Array.isArray(response.data)) {
        ventasArray = response.data;
        console.log('✅ Formato: Array directo');
      }
      // CASO 2: Objeto con success/data que contiene array
      else if (response.data?.success && Array.isArray(response.data.data)) {
        ventasArray = response.data.data;
        console.log('✅ Formato: success/data con array');
      }
      // CASO 3: Objeto único {venta, detalles}
      else if (response.data?.venta && response.data?.detalles) {
        ventasArray = [response.data];
        console.log('✅ Formato: Objeto único con venta y detalles');
      }
      // CASO 4: Objeto con success/data que contiene objeto único
      else if (response.data?.success && response.data.data?.venta) {
        ventasArray = [response.data.data];
        console.log('✅ Formato: success/data con objeto único');
      }
      else {
        console.error('❌ Formato no reconocido:', response.data);
        return {
          success: false,
          data: [],
          count: 0
        };
      }

      console.log('✅ Cantidad de ventas a procesar:', ventasArray.length);
      console.log('✅ ventasArray:', ventasArray);

      // Mapear cada venta
      const mappedVentas = ventasArray
        .map((ventaCompleta, index) => {
          try {
            console.log(`🔍 Procesando venta ${index}:`, ventaCompleta);
            
            // Si el objeto ya tiene la estructura {venta, detalles}
            if (ventaCompleta.venta && ventaCompleta.detalles) {
              console.log(`✅ Venta ${index} ya tiene estructura correcta`);
              // ✅ CAMBIO: Mapear con la clase Ventas
              return {
                venta: new Ventas(ventaCompleta.venta),  // 👈 AGREGAR ESTO
                detalles: ventaCompleta.detalles
              };
            }
            
            // Si necesita mapeo con la clase Ventas
            const venta = new Ventas(ventaCompleta);
            console.log(`✅ Venta ${index} mapeada:`, venta);
            return venta;
          } catch (mapError) {
            console.error(`❌ Error procesando venta ${index}:`, mapError);
            return null;
          }
        })
        .filter(venta => venta !== null);

      console.log('✅ VENTAS PROCESADAS:', mappedVentas);
      
      return {
        success: true,
        data: mappedVentas,
        count: mappedVentas.length
      };

    } catch (error) {
      console.error('❌ === ERROR GET VENTAS BY SUCURSAL ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error message:', error.message);
      
      if (error.response) {
        console.error('❌ Status:', error.response.status);
        console.error('❌ Data:', error.response.data);
      }
      
      return {
        success: false,
        data: [],
        count: 0,
        error: error.message
      };
    }
  }

  // ============================================
  // OBTENER VENTA POR ID (CON DETALLES)
  // ============================================
  static async getVentaById(idVenta) {
    try {
      console.log('🔍 === GET VENTA BY ID DEBUG ===');
      console.log('🔍 ID Venta:', idVenta);

      if (!idVenta) {
        throw new Error('ID de venta no proporcionado');
      }

      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.VENTAS}/${idVenta}`);
      console.log('✅ Venta obtenida:', response.data);

      const ventaData = response.data.data || response.data;
      const venta = new Ventas(ventaData);

      // Si vienen detalles en la respuesta, mapearlos también
      let detalles = [];
      if (ventaData.detalles && Array.isArray(ventaData.detalles)) {
        detalles = ventaData.detalles.map(d => new VentasDetalle(d));
      }

      return {
        success: true,
        data: {
          venta: venta,
          detalles: detalles
        }
      };

    } catch (error) {
      console.error('❌ Error obteniendo venta:', error);
      throw new Error('Error al obtener la venta: ' + (error.response?.data?.message || error.message));
    }
  }

  // ============================================
// ACTUALIZAR ESTATUS DE LA VENTA (PUT)
// ============================================
static async updateEstatus(idVenta, nuevoEstatus) {
  try {
    console.log('🔍 === UPDATE ESTATUS DEBUG ===');
    console.log('🔍 ID Venta:', idVenta);
    console.log('🔍 Nuevo Estatus:', nuevoEstatus);

    if (!idVenta) {
      throw new Error('ID de venta no proporcionado');
    }

    if (!nuevoEstatus) {
      throw new Error('Estatus no proporcionado');
    }

    // Validar que el estatus sea válido
    const estatusValidos = ['CREADO', 'ACEPTADO', 'TERMINADO', 'EN_CAMINO', 'ENTREGADO', 'CANCELADO'];
    if (!estatusValidos.includes(nuevoEstatus)) {
      console.warn('⚠️ Estatus no está en la lista de válidos:', nuevoEstatus);
    }

    // IMPORTANTE: Usar minúsculas para coincidir con el API
    const url = `${API_CONFIG.ENDPOINTS.VENTAS}/estatus/${idVenta}`;
    console.log('📤 URL completa:', API_CONFIG.BASE_URL + url);
    console.log('📤 Enviando string JSON:', nuevoEstatus);

    // CRÍTICO: Para [FromBody] string en C#, enviar el string entre comillas como JSON
    const response = await apiClient.put(
      url,
      `"${nuevoEstatus}"`,  // String con comillas dobles escapadas
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('✅ Respuesta del servidor:', response.data);

    const ventaActualizada = response.data.data || response.data;

    return {
      success: true,
      data: ventaActualizada,
      message: 'Estatus actualizado exitosamente'
    };

  } catch (error) {
    console.error('❌ === ERROR UPDATE ESTATUS ===');
    console.error('❌ Error completo:', error);
    console.error('❌ Error response:', error.response);
    
    if (error.response) {
      console.error('❌ Status:', error.response.status);
      console.error('❌ Data:', error.response.data);
      console.error('❌ Headers:', error.response.headers);
    }
    
    throw new Error('Error al actualizar estatus: ' + (error.response?.data?.message || error.message));
  }
}

// ============================================
// ACTUALIZAR TIEMPO DE PREPARACIÓN (PUT)
// ============================================
static async updateTiempo(idVenta, tiempo) {
  try {
    console.log('⏱️ === UPDATE TIEMPO DEBUG ===');
    console.log('⏱️ ID Venta:', idVenta);
    console.log('⏱️ Tiempo:', tiempo);
    
    if (!idVenta) {
      throw new Error('ID de venta no proporcionado');
    }

    if (!tiempo || tiempo <= 0) {
      throw new Error('Tiempo inválido');
    }

    const url = `${API_CONFIG.ENDPOINTS.VENTAS}/tiempo/${idVenta}`;
    console.log('📤 URL completa:', API_CONFIG.BASE_URL + url);
    console.log('📤 Enviando número:', tiempo);

    // CRÍTICO: Para [FromBody] int en C#, enviar el número directamente (sin comillas)
    const response = await apiClient.put(
      url,
      tiempo,  // Número directo, sin stringify adicional
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    console.log('✅ Respuesta del servidor:', response.data);
    
    if (response.data && response.data.success) {
      console.log('✅ Tiempo actualizado correctamente');
      return response.data;
    }
    
    // Si no viene con success, asumir que funcionó si no hubo error
    return {
      success: true,
      data: response.data
    };
    
  } catch (error) {
    console.error('❌ === ERROR UPDATE TIEMPO ===');
    console.error('❌ Error completo:', error);
    console.error('❌ Error response:', error.response);
    
    if (error.response) {
      console.error('❌ Status:', error.response.status);
      console.error('❌ Data:', error.response.data);
      console.error('❌ Headers:', error.response.headers);
    }
    
    throw new Error('Error al actualizar tiempo: ' + (error.response?.data?.message || error.message));
  }
}

  // ============================================
  // ACTUALIZAR DRIVER DE LA VENTA (PUT)
  // ============================================
  static async updateDriver(idVenta, idDriver) {
    try {
      console.log('🔍 === UPDATE DRIVER DEBUG ===');
      console.log('🔍 ID Venta:', idVenta);
      console.log('🔍 ID Driver:', idDriver);

      if (!idVenta) {
        throw new Error('ID de venta no proporcionado');
      }

      if (idDriver === undefined || idDriver === null) {
        throw new Error('ID de driver no proporcionado');
      }

      const dataToSend = {
        id_driver: idDriver
      };

      console.log('📤 Data a enviar:', dataToSend);

      const response = await apiClient.put(
        `${API_CONFIG.ENDPOINTS.VENTAS}/${idVenta}/driver`,
        dataToSend
      );

      console.log('✅ Respuesta del servidor:', response.data);

      const ventaActualizada = response.data.data || response.data;

      return {
        success: true,
        data: new Ventas(ventaActualizada),
        message: 'Driver actualizado exitosamente'
      };

    } catch (error) {
      console.error('❌ === ERROR UPDATE DRIVER ===');
      console.error('❌ Error completo:', error);
      
      if (error.response) {
        console.error('❌ Status:', error.response.status);
        console.error('❌ Data:', error.response.data);
      }
      
      throw new Error('Error al actualizar driver: ' + (error.response?.data?.message || error.message));
    }
  }

  // ============================================
  // ASIGNAR DRIVER Y CAMBIAR ESTATUS (PUT)
  // ============================================
  static async asignarDriver(idVenta, idDriver, nuevoEstatus = 'EN_CAMINO') {
    try {
      console.log('🔍 === ASIGNAR DRIVER DEBUG ===');
      console.log('🔍 ID Venta:', idVenta);
      console.log('🔍 ID Driver:', idDriver);
      console.log('🔍 Nuevo Estatus:', nuevoEstatus);

      if (!idVenta) {
        throw new Error('ID de venta no proporcionado');
      }

      if (idDriver === undefined || idDriver === null) {
        throw new Error('ID de driver no proporcionado');
      }

      const dataToSend = {
        id_driver: idDriver,
        estatus: nuevoEstatus
      };

      console.log('📤 Data a enviar:', dataToSend);

      const response = await apiClient.put(
        `${API_CONFIG.ENDPOINTS.VENTAS}/${idVenta}/asignar-driver`,
        dataToSend
      );

      console.log('✅ Respuesta del servidor:', response.data);

      const ventaActualizada = response.data.data || response.data;

      return {
        success: true,
        data: new Ventas(ventaActualizada),
        message: 'Driver asignado exitosamente'
      };

    } catch (error) {
      console.error('❌ === ERROR ASIGNAR DRIVER ===');
      console.error('❌ Error completo:', error);
      
      if (error.response) {
        console.error('❌ Status:', error.response.status);
        console.error('❌ Data:', error.response.data);
      }
      
      throw new Error('Error al asignar driver: ' + (error.response?.data?.message || error.message));
    }
  }

  // ============================================
  // ACTUALIZAR VENTA COMPLETA (PUT)
  // ============================================
  static async updateVenta(idVenta, ventaData) {
    try {
      console.log('🔍 === UPDATE VENTA DEBUG ===');
      console.log('🔍 ID Venta:', idVenta);
      console.log('🔍 Data:', ventaData);

      if (!idVenta) {
        throw new Error('ID de venta no proporcionado');
      }

      let venta;
      if (ventaData instanceof Ventas) {
        venta = ventaData;
      } else {
        venta = new Ventas(ventaData);
      }

      // Validar
      if (!venta.isValid()) {
        const errors = venta.getValidationErrors();
        throw new Error('Datos inválidos: ' + errors.join(', '));
      }

      const dataToSend = venta.toApiFormat();
      console.log('📤 Data a enviar:', dataToSend);

      const response = await apiClient.put(
        `${API_CONFIG.ENDPOINTS.VENTAS}/${idVenta}`,
        dataToSend
      );

      console.log('✅ Venta actualizada:', response.data);

      const ventaActualizada = response.data.data || response.data;
      
      return {
        success: true,
        data: new Ventas(ventaActualizada),
        message: 'Venta actualizada exitosamente'
      };

    } catch (error) {
      console.error('❌ Error actualizando venta:', error);
      throw new Error('Error al actualizar la venta: ' + (error.response?.data?.message || error.message));
    }
  }

  // ============================================
  // CANCELAR VENTA
  // ============================================
  static async cancelarVenta(idVenta, motivo = '') {
    try {
      console.log('🔍 Cancelando venta ID:', idVenta);
      console.log('🔍 Motivo:', motivo);

      return await this.updateEstatus(idVenta, 'CANCELADO');

    } catch (error) {
      console.error('❌ Error cancelando venta:', error);
      throw new Error('Error al cancelar la venta: ' + error.message);
    }
  }

  // ============================================
  // ELIMINAR VENTA (DELETE)
  // ============================================
  static async deleteVenta(idVenta) {
    try {
      console.log('🔍 Eliminando venta ID:', idVenta);
      
      if (!idVenta) {
        throw new Error('ID de venta no proporcionado');
      }

      await apiClient.delete(`${API_CONFIG.ENDPOINTS.VENTAS}/${idVenta}`);
      console.log('✅ Venta eliminada exitosamente');
      
      return {
        success: true,
        message: 'Venta eliminada exitosamente'
      };

    } catch (error) {
      console.error('❌ Error eliminando venta:', error);
      throw new Error('Error al eliminar la venta: ' + (error.response?.data?.message || error.message));
    }
  }

  // ============================================
  // OBTENER ESTADÍSTICAS DE VENTAS POR SUCURSAL
  // ============================================
  static async getEstadisticas(idSucursal, fechaInicio = null, fechaFin = null) {
    try {
      console.log('🔍 === GET ESTADÍSTICAS DEBUG ===');
      console.log('🔍 ID Sucursal:', idSucursal);
      console.log('🔍 Fecha Inicio:', fechaInicio);
      console.log('🔍 Fecha Fin:', fechaFin);

      if (!idSucursal) {
        throw new Error('ID de sucursal no proporcionado');
      }

      // Construir query params
      let queryParams = `id_sucursal=${idSucursal}`;
      if (fechaInicio) queryParams += `&fecha_inicio=${fechaInicio}`;
      if (fechaFin) queryParams += `&fecha_fin=${fechaFin}`;

      const url = `${API_CONFIG.ENDPOINTS.VENTAS}/estadisticas?${queryParams}`;
      console.log('🔍 URL:', url);

      const response = await apiClient.get(url);
      console.log('✅ Estadísticas obtenidas:', response.data);

      return {
        success: true,
        data: response.data.data || response.data
      };

    } catch (error) {
      console.error('❌ Error obteniendo estadísticas:', error);
      throw new Error('Error al obtener estadísticas: ' + (error.response?.data?.message || error.message));
    }
  }

  // ============================================
  // MÉTODO DE PRUEBA
  // ============================================
  static async testConnection() {
    try {
      console.log('🧪 === TEST CONNECTION VENTAS ===');
      console.log('🧪 URL Base:', API_CONFIG.BASE_URL);
      console.log('🧪 Endpoint:', API_CONFIG.ENDPOINTS.VENTAS);
      console.log('🧪 URL Completa:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.VENTAS);
      
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.VENTAS);
      console.log('✅ ¡CONEXIÓN EXITOSA!');
      console.log('✅ Response completo:', response);
      console.log('✅ Response data:', response.data);
      
      return response;
    } catch (error) {
      console.error('❌ FALLO EN LA CONEXIÓN:', error);
      console.error('❌ Error response:', error.response);
      return error;
    }
  }
}